<template>
    <div>
        <headerNav title="银行卡列表" />
        <div class="bmian">
            <div class="bmian-info bmain-list" v-for="(item,index) in branklist" @click="edit(item)" :key="index">
                <div class="bmian-info-tit">
                    <span>{{item.fullName}}</span>
                    <van-tag round  type="danger" v-if="item.isDefault">默认</van-tag>
                </div>
                <div>
                    <span>{{item.cardNo}}</span>
                </div>
                <div>
                    <span >{{item.openAccountBank}}</span>
                </div>
                <van-icon name="clear" @click.stop="brankdelete(item)"  class="picon sicon" :size="fsize" :color="$abctheme.basecolor"/>
            </div>
            <div class="bmian-info bfooter">
                <div class="bfooter-btns">
                    <van-button round block class="setbtns" @click="goto('/setbrank')" :color="$abctheme.basecolor">添加银行卡</van-button>
                </div>
            </div>
           
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return {
            fsize:25,
            branklist:[]
        }
    },
    created(){
        this.querydata();
    },
    methods:{
        querydata(){
            this.ajax.post('/api/services/app/PhoneUser/QueryBankList').then((x)=>
            {
                this.branklist=x.result;
            });
        },
        goto(url)
        {
            this.$router.push({path:url});
        },
        edit(item)
        {
            this.$router.push({name:'setbrank',params:{item:item}})
        },
        brankdelete(item)
        {
            this.ajax.post('/api/services/app/PhoneUser/BrankDelete',{id:item.id}).then(()=>
            {
                this.$toast('删除成功');
                this.querydata();
            });
            
        }
    }
}
</script>
<style lang="scss" scoped>
    .bmian{
        margin: 10px;
        font-size: 12px;
    }
    .bmian-info{
        padding: 10px;
        background-color: #fff;
        position: relative;
    }
    .bmain-list
    {
        border-radius: 4px;
        box-shadow: 1px 1px 4px #dcdcdc;
        font-size: 14px;
        line-height: 25px;
        word-break: break-all;
        margin-bottom: 20px;
    }
    .bmian-info div:first-child
    {
        padding-top:0;
    }
    .bmian-info div:last-child
    {
        padding-bottom: 0;
    }
    .bmian-info-right{
        float: right;
    }
    .picon{
        position: absolute;
        top:5px;
        right: 5px;
    }
    .bfooter{
        position: absolute;
        left:0;
        right: 0;
        bottom: 0;
        z-index:99;
    }
    .bfooter button
    {
        background-color: red;
        color:white;
    }
</style>